import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type Signal = {
  id: string;
  name: string;
};

// eslint-disable-next-line import/prefer-default-export
export function useSignals() {
  return useQuery<Signal[]>({
    queryKey: [APIKey.SIGNALS],
    queryFn: () => baseFetcher(apiRoutes.signals()),
    retry: false,
  });
}
